import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { opacity: "0.4" }, [
      _createElementVNode("path", {
        d: "M9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9C16.5 13.1421 13.1421 16.5 9 16.5ZM8.25 11.25V12.75H9.75V11.25H8.25ZM9.75 10.0163C10.8343 9.6936 11.625 8.68913 11.625 7.5C11.625 6.05025 10.4497 4.875 9 4.875C7.7265 4.875 6.66478 5.78189 6.42548 6.9851L7.8966 7.27933C7.9992 6.76367 8.45423 6.375 9 6.375C9.6213 6.375 10.125 6.87868 10.125 7.5C10.125 8.1213 9.6213 8.625 9 8.625C8.58577 8.625 8.25 8.96077 8.25 9.375V10.5H9.75V10.0163Z",
        fill: "#373737"
      })
    ], -1)
  ])))
}
export default { render: render }